import { BrowserStorage } from '@estee/elc-universal-utils';
import { VTO_MATCHES_COOKIE_NAME } from '../constants/Vto';
import { IVtoMatchCookie } from '../interfaces/IVto';
import { getVtoMatchCookie } from './getVtoMatchCookie';

interface ISetVtoMatchCookie {
    shadeMatches: IVtoMatchCookie;
    shouldOverride: boolean;
}

export const setVtoMatchCookie = (params: ISetVtoMatchCookie) => {
    let formerShadeMatches = {};

    const { shadeMatches, shouldOverride } = params;

    const shadeMatchCookie = getVtoMatchCookie();

    if (shadeMatchCookie) {
        try {
            formerShadeMatches = JSON.parse(shadeMatchCookie);
        } catch (e) {
            console.warn(e);
        }
    }

    const newShadeMatches = shouldOverride
        ? { ...formerShadeMatches, ...shadeMatches }
        : { ...shadeMatches, ...formerShadeMatches };

    BrowserStorage.setItem(VTO_MATCHES_COOKIE_NAME, JSON.stringify(newShadeMatches));
};
